@if (product$ | async; as product) {
  <div [innerHTML]="product?.summary"></div>
}
